import DOM from '@common/DOM/DOM'

import './Video.scss'

interface IPlyr {
  readonly play: TVoidCallback
  readonly pause: TVoidCallback
  readonly togglePlay: TVoidCallback
  readonly on: (event: string, callback: TVoidCallback) => void
  // oxlint-disable-next-line typescript/naming-convention
  readonly touch: boolean
}

class Video extends HTMLElement {
  private plyr: IPlyr | null = null

  private get youtebeId (): string {
    return this.getAttribute('youtube-id') ?? ''
  }

  public connectedCallback (): void {
    this.appendChild(
      <div data-plyr data-plyr-embed-id={ this.youtebeId } data-plyr-provider="youtube">
        <img
          width="100%"
          alt="Videó thumbnail"
          draggable={ false }
          loading="lazy"
          src={ `https://wsrv.nl?output=webp&url=https://img.youtube.com/vi/${ this.youtebeId }/maxresdefault.jpg` }
        />

        <div className="video__play-icon-container">
          <img
            alt="Videó lejátszása"
            draggable={ false }
            src={ require('../../images/video-play-icon.png') }
          />
        </div>
      </div>
    )

    this.addEventListener('click', this.onClick)
  }

  public disconnectedCallback (): void {
    this.removeEventListener('click', this.onClick)

    document.removeEventListener('click', this.onClickOutside)
  }

  /** Kattintás esemény kezelése. */
  private readonly onClick = async (): Promise<void> => {
    if (this.plyr) {
      if (this.plyr.touch) {
        this.plyr.togglePlay()
      }

      return
    }

    document.addEventListener('click', this.onClickOutside)

    const elem = this.querySelector('[data-plyr]')

    if (!elem) {
      return
    }

    await Promise.all([
      DOM.createStyle('https://cdn.plyr.io/3.7.8/plyr.css'),
      DOM.createScript('https://cdn.plyr.io/3.7.8/plyr.js')
    ])

    // @ts-expect-error -- Ott van az
    // oxlint-disable-next-line typescript/no-unsafe-call
    this.plyr = new Plyr(elem, { controls: [ 'play-large', 'progress' ] })

    this.plyr?.on('ready', () => {
      this.plyr?.play()
    })
  }

  /**
   * Videó elemen kívüli kattintás esetén a videó leállítása.
   * @param e - Event.
   */
  private readonly onClickOutside = (e: Event): void => {
    if (!e.composedPath().includes(this) && this.plyr) {
      this.plyr.pause()
    }
  }
}

customElements.define('imm-video', Video)
